import { MARKETPLACE, SHOP_NAME } from "@acc/shared"
import BaseApi from "../../../api/api"
import { IOrder, ISupply } from "../../../app/reducers/ordersReducer"
import { NotificationService } from "../../../features/NotificationService/NotificationService"
import { loadAuditFormOrder } from "../../../utils/auditFormOrder"
import {
  MissOrderkatren,
  RecodeForOrderkatren,
  RecodeKatren,
} from "../FormKatrenOrder"

export const getWBOrdersForKatren = (
  supplies: ISupply[],
): Promise<{
  recodeForOrderkatren: RecodeForOrderkatren[]
  missOrders: MissOrderkatren[]
}> => {
  const orders: IOrder[] = supplies?.reduce<IOrder[]>((res, supp) => {
    return [...res, ...(supp?.orders || [])]
  }, [])
  return Promise.all([
    BaseApi.getWBKatrenRecode(),
    loadAuditFormOrder(
      SHOP_NAME.KATREN,
      MARKETPLACE.WB,
      supplies.map((supply) => supply.id),
    ),
  ]).then(
    ([{ items, success }, audit]: [
      { items: RecodeKatren; success: boolean },
      audit: { date: string; value: string }[][],
    ]) => {
      if (success) {
        const info = audit?.reduce<
          {
            name: string
            value: string
            count: number
            date: string
          }[]
        >((acc, item) => {
          if (item.length) {
            const firstItem = item.sort(
              (a, b) => (new Date(b.date) as any) - (new Date(a.date) as any),
            )?.[0]
            const supp = supplies.find(
              (supply) => supply.id === firstItem.value,
            )
            supp &&
              acc.push({
                name: supp?.name,
                value: firstItem.value,
                count: item.length,
                date: firstItem.date,
              })
          }
          return acc
        }, [])

        if (items?.length) {
          const missOrders: MissOrderkatren[] = []
          const recodeForOrderkatrenMap = new Map<
            string,
            RecodeForOrderkatren
          >()
          orders.forEach((order) => {
            const recodeItem = items.find((item) => item.nmId === order.nmId)
            if (recodeItem?.GoodCode) {
              if (recodeForOrderkatrenMap.has(recodeItem.GoodCode)) {
                const recodeForOrderkatrenItem = recodeForOrderkatrenMap.get(
                  recodeItem.GoodCode,
                )
                if (recodeForOrderkatrenItem) {
                  recodeForOrderkatrenItem.Quantity +=
                    Number(recodeItem.count) || 0
                } else {
                  recodeForOrderkatrenMap.set(recodeItem.GoodCode, {
                    GoodName: recodeItem.GoodName,
                    GoodCode: recodeItem.GoodCode,
                    Quantity: Number(recodeItem.count) || 0,
                  })
                }
              } else {
                recodeForOrderkatrenMap.set(recodeItem.GoodCode, {
                  GoodName: recodeItem.GoodName,
                  GoodCode: recodeItem.GoodCode,
                  Quantity: Number(recodeItem.count) || 0,
                })
              }
            } else {
              missOrders.push({ nmId: order.nmId, GoodCode: order.article })
            }
          })

          return {
            recodeForOrderkatren: Array.from(recodeForOrderkatrenMap.values()),
            missOrders,
            info,
          }
        } else {
          NotificationService.showNotification({
            message: "Перекодировка не найдена",
            level: "error",
          })
          throw new Error("Перекодировка не найдена")
        }
      } else {
        NotificationService.showNotification({
          message: "Ошибка при загрузке перекодировки",
          level: "error",
        })
        throw new Error("Ошибка при загрузке перекодировки")
      }
    },
  )
}
